module.exports = __webpack_public_path__ + "hyperion-v2-static/img/baselayer-street-btn-60x60.e8faba7d.png";